import React, {Component} from 'react';
import {MenuItem, Typography} from "@material-ui/core";
import PropTypes from 'prop-types';

import {
    ContainerInputStyled,
    ContainerModalStyled,
    FixSelectStyled,
    ItemModalStyled,
    ParentModalStyled,
    ParentStyled
} from "./styled";
import SpacerComponent from "../SpacerComponent/SpacerComponent";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TextFieldDefault from "../TextFieldDefaultComponent/TextFieldDefault";

class AutocompleteComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            autocomplete: null,
        };
    }

    open = () => {
        this.setState({open: true});
    }

    handleChange = (event) => {
        const {name, value} = event.target;
        this.setState({[name]: value});
    }

    makeItems = () => {
        const items = [];

        this.props.items.map((element) => {

            console.log(JSON.stringify(element) === JSON.stringify(this.props.selected));

            if (this.state.autocomplete && !this.props.getLabelTitle(element).toUpperCase().includes(this.state?.autocomplete.toUpperCase())) {
                return <></>;
            }

            items.push(
                <ItemModalStyled onClick={() => this.selected(element)}>
                    <Typography variant={'body2'}>
                        {this.props.getLabelTitle(element)}
                    </Typography>
                </ItemModalStyled>
            );

        });

        return items;
    }

    selected = (element) => {
        this.setState({open: false});
        this.props?.onSelect(element);
    }

    render() {
        return (
            <ParentStyled>
                <Typography variant={'body1'}
                            color={'primary'}
                            style={{marginRight: 5}}>
                    {this.props.label}
                </Typography>
                <SpacerComponent height={17}/>
                <ContainerInputStyled onClick={this.open}>
                    {this.state.open &&
                        <input name={'autocomplete'}
                               placeholder={'Digitie para buscar'}
                               value={this.state?.autocomplete}
                               onChange={(event) => this.handleChange(event)}/>

                    }
                    {!this.state.open &&
                        <Typography variant={'body2'}
                                    style={{marginRight: 5}}>
                            {this.props.getLabelTitle(this.props.selected) ?? 'Digitie para buscar'}
                        </Typography>
                    }
                    <ArrowDropDownIcon/>
                </ContainerInputStyled>
                {this.state.open &&
                    <div>
                        <ParentModalStyled>
                            <SpacerComponent height={10}/>
                            <ContainerModalStyled elevation={3}>
                                {this.makeItems()}
                            </ContainerModalStyled>
                        </ParentModalStyled>
                    </div>
                }
            </ParentStyled>
        );
    }
}


AutocompleteComponent.propTypes = {
    time: PropTypes.number,
};

export default AutocompleteComponent;